import { fetchWelcome, fetchAges, fetchStays } from "./api";
import { formatDate, diffDates } from "./utils";
import { parameterValue } from "./location";

const WEDNESDAY = 3;
const SATURDAY = 6;

export const addDays = (date, days) => {
  const retVal = new Date(date);
  retVal.setDate(retVal.getDate() + days);
  return retVal;
};

const checkLocalStorage = () => {
  if (localStorage.startDate !== undefined) {
    const startDate = new Date(localStorage.startDate);
    const now = new Date();

    if (formatDate(startDate) < formatDate(now)) {
      localStorage.removeItem("startDate");
      localStorage.removeItem("endDate");
      localStorage.removeItem("minDuration");
      localStorage.removeItem("maxDuration");
    }
  }
};

const extractAgeDate = date => ({
  year: date.getFullYear(),
  month: date.getMonth() + 1,
  date: date.getDate()
});

const computeAgeRanges = choices => {
  const start = new Date(choices[0].range.max);
  const stop = new Date(choices[choices.length - 1].range.min);
  start.setDate(start.getDate() - 1);
  stop.setDate(stop.getDate() + 1);
  return {
    min: extractAgeDate(start),
    max: extractAgeDate(stop)
  };
};

const computePossibleStays = (intermediary, resort, lang, season) =>
  fetchStays(intermediary, resort, lang, season).then(result => {
    const { choices } = result;
    const min = new Date(choices[0].from);
    const max = new Date(choices[choices.length - 1].to);
    return { min, max };
  });

const getStartDate = stayFrom => {
  const fromDay = stayFrom.getDay();
  return addDays(stayFrom, fromDay >= WEDNESDAY ? SATURDAY - fromDay : 0);
};

const getStayTo = (stayFrom, max, endDate) => {
  if (endDate !== undefined && endDate !== "") {
    return new Date(endDate);
  }

  const stayDay = stayFrom.getDay();

  const delta = stayDay === SATURDAY ? 7 : SATURDAY - stayDay;

  const end = addDays(stayFrom, delta);
  return end > max ? max : end;
};

export const computeStayDatesAuto = (min, max) => {
  const now = new Date();
  const stayFrom = getStartDate(now < min ? min : now);
  const stayTo = getStayTo(stayFrom, max);

  return {
    stayFrom,
    stayTo
  };
};

export const getStay = (
  intermediary,
  resort,
  lang,
  season,
  startDate,
  endDate,
  minDuration,
  maxDuration
) =>
  computePossibleStays(intermediary, resort, lang, season).then(
    ({ min, max }) => {
      const dateParam = parameterValue("date");

      const now =
        dateParam !== undefined
          ? new Date(dateParam)
          : startDate !== undefined && startDate !== ""
          ? new Date(startDate)
          : new Date();

      const stayFrom =
        startDate !== undefined && startDate !== ""
          ? new Date(startDate)
          : getStartDate(now < min ? min : now);
      const stayTo = getStayTo(stayFrom, max, endDate);

      return {
        stayFrom: formatDate(stayFrom),
        stayTo: formatDate(stayTo),
        min,
        max,
        startDate,
        endDate,
        minDuration,
        maxDuration:
          maxDuration === undefined ? diffDates(stayFrom, stayTo) : maxDuration
      };
    }
  );

export const createInscription = (intermediary, resort, lang) => {
  checkLocalStorage();
  const startDate =
    localStorage.startDate !== undefined ? localStorage.startDate : "";
  const endDate =
    localStorage.endDate !== undefined ? localStorage.endDate : "";
  return fetchWelcome(intermediary, resort, lang).then(resp => {
    const { season } = resp;
    const minDuration =
      localStorage.minDuration !== undefined
        ? parseInt(localStorage.minDuration, 10)
        : 1;
    const maxDuration =
      localStorage.maxDuration !== undefined
        ? parseInt(localStorage.maxDuration, 10)
        : undefined;

    return season !== undefined
      ? getStay(
          intermediary,
          resort,
          lang,
          season,
          startDate,
          endDate,
          minDuration,
          maxDuration
        ).then(stay => ({
          season,
          ...stay
        }))
      : { stayFrom: new Date(startDate), stayTo: new Date(endDate) };
  });
};

export const fetchAgeRanges = (
  intermediary,
  resort,
  lang,
  season,
  stayFrom,
  stayTo
) => {
  return fetchAges(intermediary, resort, lang, season, stayFrom, stayTo).then(
    result => {
      const { choices, error } = result;
      return choices !== undefined && choices.length > 0
        ? computeAgeRanges(choices)
        : { error };
    }
  );
};



// WEBPACK FOOTER //
// ./src/services/clubmed.js